import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID';
import { useMemo, useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';
import { IIconProps } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	className?: string;
	tooltip: string;
	iconSize?: IIconProps['size'];
	hoverChildrenInsteadIcon?: boolean;
	children?: React.ReactNode;
	dataTestId?: string;
}
// https://www.npmjs.com/package/react-tooltip
const Tooltip = ({
	className,
	tooltip,
	iconSize,
	dataTestId,
	hoverChildrenInsteadIcon: hoverChildren = false,
	...props
}: Props) => {
	const [id] = useState(generateUUID());

	const dataProps = useMemo(() => {
		return Object.entries(props)
			.map(([key, value]) => {
				return [`data-${key}`, value];
			})
			.reduce((hashMap, [key, value]) => {
				return { ...hashMap, [`${key}`]: value };
			}, {});
	}, [props]);

	return (
		<div data-testid={dataTestId} className={className}>
			<ReactTooltip id={id} content={tooltip} />
			{hoverChildren ? (
				<div {...dataProps} data-tooltip-id={id}>
					{props.children}
				</div>
			) : (
				<TooltipIconWrapper {...dataProps} data-tooltip-id={id}>
					<Icon variant="i-circle" size={iconSize} />
				</TooltipIconWrapper>
			)}
		</div>
	);
};

export const TooltipIconWrapper = styled.div`
	cursor: help;
`;

const Styled = styled(Tooltip)`
	display: flex;
	align-items: center;

	& .react-tooltip {
		z-index: 999;
		font-family: 'Inter', sans-serif !important;
		max-width: 30rem;
		line-height: 130%;
		white-space: pre-line;
		text-transform: none;
	}

	& > ${TooltipIconWrapper} > ${Icon} {
		margin-left: 0.5rem;
	}
`;

export { Styled as Tooltip };
